import bugsnagClient from "@/utilities/bugsnag";

export function downloadAttachments(url:string,title:string){
    let a = document.createElement("a");
    a.href = url;
    a.setAttribute("target", '_blank');
    a.setAttribute("download", title);
    a.click();
    a.remove(); //always remove this temporary element
}
export class Attachments {
  
    constructor() {}

    async getAttachment(attachment:any){
        try{
            let resp = await window.botClient.getAttachment(attachment.id);
            if(resp){
                let attachmentData: any = resp;
                return attachmentData;
            }else{
                console.error("cannot get attachments");
            }
        }catch(err){
            console.error("cannot get attachments", err);
            bugsnagClient.notify(err as any);
        }
    }
}